import { BackendConfigSiteInterface } from 'common/data/backend/config/site.interface';

/**
 * Default site configuration
 */
export const BackendConfigSiteDefault: BackendConfigSiteInterface = {
  name: 'propertyfinder',
};
